import { createAction } from '@reduxjs/toolkit';

import { SIGN_IN_WITH_AUTH0_USER } from 'constants/redux-actions';

const signInWithAuth0User = createAction(SIGN_IN_WITH_AUTH0_USER);

const auth0Actions = { signInWithAuth0User };

export default auth0Actions;
